module.exports = require('./container');